<!-- <div id="modal-content-wrapper">
  <header id="modal-header">
    <h1 id="modal-title">{{modalData.title}}</h1>
  </header>
  <section id="modal-body">
    <p>{{modalData.description}}</p>
  </section>
  <footer id="modal-footer">
    <button mat-raised-button id="modal-action-button" (click)="actionFunction()">
      {{modalData.actionButtonText}}
    </button>
    <button mat-raised-button id="modal-cancel-button" (click)="closeModal()">
    Torna indietro
    </button>
  </footer>
</div> -->

<div id="modal-content-wrapper">
  <h1 mat-dialog-title>
    {{modalData.title}}
  </h1>
  <div mat-dialog-content>
    {{modalData.description}}
  </div>
  <div mat-dialog-actions class="d-flex justify-content-end py-4">
    <button mat-stroked-button mat-dialog-close color="primary" (click)="closeModal()">ANNULLA</button>
    <button mat-raised-button mat-dialog-close color="primary" class="text-uppercase" (click)="actionFunction()">
      {{modalData.actionButtonText}}
    </button>
  </div>
</div>

